module.exports = __webpack_public_path__ + "img/certificate_020302515_00.e80552a5.jpg";